import { useRegistryItems } from './useRegistryItems';
import { RegistryCategoryMatrixID } from '../types/registry';

export const useProducts = (eventProductIds?: string[]) => {
  return useRegistryItems(RegistryCategoryMatrixID.PRODUCT_MATRIX_ID, eventProductIds);
};
